import React, { useRef, useState } from 'react';
import { httpAchievementDetails, httpDeptFilter, httpDictServ } from '@/services/customerServices';
import { SLowcodeList, STableActions, SActionBtn } from 'shj-components';
import { Button, message, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import AddOrEdit from './AddOrEdit';
import config from './config';
import { fetchList, getCategoryFn, getCompanyFn, onExportFn, onWeekEditFn } from './funs';
import './index.less'
import { getUser } from '@/common/utils.ts'

/**
 * 目标管理 - 公司组件
 * @returns {ReactNode}
 */
const Company: React.FC<any> = () => {
  const userInfo = getUser();
  const [editData, setEditData] = useState<any>({});
  const company = useRef<any>([]);
  const category = useRef<any>([]);
  const listRef = useRef<any>();
  const [fileList, setFileList] = useState<any>();
  const [id, setId] = useState<number | undefined>(undefined);
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const onAdd = () => {
    setId(undefined);
    setEditData({});
    setIsVisible(true);
  };

  /** 统一请求方法 */
  const getSelect = () => {
    return new Promise((resolve) => {
      Promise.all([
        getCompanyFn(company),
        httpDictServ({ parentKey: 'productionType', enable: 1 }),
        getCategoryFn(category),
        httpDeptFilter(
          {
            companyCodes: userInfo && userInfo?.extend && [userInfo?.extend?.companyCode],
            functionCodes: ['marketing', 'design', 'YLmarketing']
          })
      ]).then((result: any) => {
        resolve({
          company: result[0],
          productType: result[1],
          category: result[2],
          dept: result[3],
        });
      });
    });
  };

  /**
   * 编辑
   * @param record - table row数据集合
   */
  const onEdit = async (record: { [key: string]: any }) => {
    try {
      setIsVisible(true);
      // const resData: any = await httpAchievementDetails({}, record.id)
      // setEditData({ ...resData, companyId: resData.companyId });
      setEditData({ ...record});
      setId(record.id);
    } catch (error) {
      console.log('error', error);
    }
  };

  /** 导出方法 */
  const onExport = () => {
    const { getFieldsValue } = listRef.current.getSearch();
    const values = getFieldsValue()
    onExportFn(values)
  };

  /** 
   * 上传
   * @param {object} info - 上传文件信息
   */
  const onUpload = (info: any) => {
    setFileList(info.fileList);
    if (info.file.status === 'done') {
      listRef.current.reload();
    } else if (info.file.status === 'error') {
      message.error(info.file.response.message, 8);
    }
  };
  const uploadProps = {
    name: 'file',
    multiple: false,
    onChange: onUpload,
    fileList: fileList,
  };

  /**
   * 表格通用配置
   */
  const extension = {
    request: { fetchList, getSelect },
    events: { onAdd, onExport },
    customRender: {
      upload() {
        <Upload {...uploadProps}>
          <Button type="primary" icon={<UploadOutlined />}>
            导入目标
          </Button>
        </Upload>;
      },
      actionTool(text: any, record: any) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>
              编辑
            </SActionBtn>
            <SActionBtn onClick={() => onWeekEditFn(record)}>
              同步周次配置
            </SActionBtn>
          </STableActions>
        );
      },
    },
  };
  return (
    <div className='objectiveCompany'>
      <SLowcodeList config={config} ref={listRef} {...extension} />
      <AddOrEdit
        editData={editData}
        company={company}
        category={category}
        id={id}
        setVisible={setIsVisible}
        visible={isVisible}
        listRef={listRef}
      />
    </div>
  );
};

export default Company;
